import React from 'react'
import { useAppSelector } from '@SonarCX/hooks/redux'
import clsx from 'clsx'
import { ArrowDown2 } from 'iconsax-react'

import ButtonMenu from '../ButtonMenu'

import { useBreakpoint } from '@SonarCX/providers/BreakpointProvider'
import { selectRole } from '@SonarCX/slices/role'

import useStyles from './styles'

const getRoleName = roles => id => {
  if (!id) {
    return 'Unassigned'
  }

  const role = roles[id]
  if (role) {
    return role.name
  } else {
    return 'Loading...'
  }
}

const RolesMenu = ({
  selected,
  customOptions = undefined,
  onSelect,
  className = '',
  ...props
}) => {
  const { roles } = useAppSelector(selectRole)
  const { isSmall } = useBreakpoint()

  const options = React.useMemo(
    () => customOptions ?? [...Object.values(roles).map(roles => roles.id)],
    [customOptions, roles]
  )

  const classes = useStyles({ smallMedia: isSmall })

  return (
    <ButtonMenu
      options={options}
      onSelect={onSelect}
      selected={selected ?? 'null'}
      renderFunc={getRoleName(roles)}
      className={clsx(classes.root, className)}
      {...props}
    >
      {getRoleName(roles)(selected)}

      <ArrowDown2 className={classes.icon} />
    </ButtonMenu>
  )
}

export default RolesMenu
